var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// Utils
import { createTable, getCoreRowModel } from '@tanstack/table-core';
import { getColumns } from '../utils/getColumns';
// Hooks
import { useMemo } from 'react';
export var useTable = function (tableId, columnConfigs, data, initialState) {
    return useMemo(function () {
        var columns = getColumns(columnConfigs);
        var table = createTable({
            data: data,
            columns: columns,
            getCoreRowModel: getCoreRowModel(),
            onStateChange: function () { },
            renderFallbackValue: null,
            initialState: initialState,
            state: {},
            enablePinning: false,
            meta: {
                tableId: tableId,
            },
        });
        table.setOptions(function (prev) { return (__assign(__assign({}, prev), { state: __assign(__assign({}, prev.state), table.initialState) })); });
        return table;
    }, [columnConfigs, data, tableId, initialState]);
};
//# sourceMappingURL=useTable.js.map